// This file is part of InvenioRequests
// Copyright (C) 2022 CERN.
//
// Invenio RDM Records is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.
export const payloadSerializer = (content, format) => ({
  payload: {
    content,
    format,
  },
});

export const normalizeInternalUrl = (url) => {
  if (
    typeof window === "undefined" ||
    typeof window.location?.origin !== "string" ||
    typeof url !== "string" ||
    !/^https?:\/\//i.test(url)
  ) {
    return url;
  }

  try {
    const parsedUrl = new URL(url);
    if (parsedUrl.origin === window.location.origin) {
      return url;
    }

    const internalPrefixes = [
      "/api/",
      "/uploads",
      "/records",
      "/collections",
      "/communities",
      "/me",
      "/account",
      "/login",
      "/logout",
      "/oauth",
      "/requests",
    ];

    if (!internalPrefixes.some((prefix) => parsedUrl.pathname.startsWith(prefix))) {
      return url;
    }

    return new URL(
      `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`,
      window.location.origin
    ).toString();
  } catch (error) {
    return url;
  }
};

export const normalizeLinkContainer = (value) => {
  if (Array.isArray(value)) {
    return value.map((item) => normalizeLinkContainer(item));
  }

  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, normalizeLinkContainer(item)])
    );
  }

  return normalizeInternalUrl(value);
};

export const errorSerializer = (error) =>
  error?.response?.data?.message || error?.message;
